import { Fragment, ReactElement, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import FormAssignOperator from './form';

const AssignAccordion = (): ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-assign-operator-content"
          id="panel-assign-operator-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Assegna pratica ad altro operatore</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormAssignOperator />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AssignAccordion.displayName = 'Practice Assign - assign to operator component';

export default AssignAccordion;
